import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    public router: Router,
    private toasterService: ToastService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip preflight requests (OPTIONS method)
    if (request.method === 'OPTIONS') {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) { }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle connection reset and preflight errors specifically
        if (error.status === 0) {
          if (error.message?.includes('connection reset') || 
              error.message?.includes('connection closed')) {
            console.warn('Connection reset/closed detected:', error.message);
            // Don't show toast for connection resets, let retry logic handle it
            return throwError(error);
          }
          // CORS preflight failure
          console.warn('CORS or network error:', error);
          return throwError(error);
        }

        let errorMessages = [];
        switch (error.status) {
          case 400:
            if (error.error?.error) {
              this.toasterService.error(error.error.error);
            }
            break;
          case 401:
            // sessionStorage.clear();
            // this.router.navigate(['/']);
            // window.location.reload()
            break;
          case 403:
            console.warn('Forbidden access');
            break;
          case 404:
            console.warn('Resource not found');
            break;
          case 422:
            if (error.error?.error) {
              //use toaster
            } else if (error.error?.errors) {
              for (let iRow in error.error.errors) {
                for (let jRow in error.error.errors[iRow]) {
                  errorMessages.push(error.error.errors[iRow][jRow])
                }
              }
              //open error dialog box
            }
            break;
          case 500:
            console.error('Server error:', error);
            break;
          case 502:
          case 503:
          case 504:
            console.warn('Server temporarily unavailable:', error.status);
            break;
          default:
            if (error.status >= 500) {
              console.error('Server error:', error);
            }
            break;
        }
        //throw error as per requirement
        return throwError(error);
      })
    );
  }
}
